class WoodifyHeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.index = 0;
    this.autoplayDelay = Number(this.dataset.autoplayDelay || 5000);

    this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.show(0);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  show(nextIndex) {
    if (!this.slides.length) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.toggleAttribute('data-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
  }

  start() {
    this.stop();
    if (this.slides.length > 1 && this.autoplayDelay > 0) {
      this.timer = window.setInterval(() => this.show(this.index + 1), this.autoplayDelay);
    }
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
  }
}

if (!customElements.get('woodify-hero-slider')) {
  customElements.define('woodify-hero-slider', WoodifyHeroSlider);
}
